import PDFName from '../../core/objects/PDFName.js';
import PDFNumber from '../../core/objects/PDFNumber.js';
// TODO: Also handle the `/S` and `/D` entries
class BorderStyle {
    dict;
    static fromDict = (dict) => new BorderStyle(dict);
    constructor(dict) {
        this.dict = dict;
    }
    W() {
        const W = this.dict.lookup(PDFName.of('W'));
        if (W instanceof PDFNumber)
            return W;
        return undefined;
    }
    getWidth() {
        return this.W()?.asNumber() ?? 1;
    }
    setWidth(width) {
        const W = this.dict.context.obj(width);
        this.dict.set(PDFName.of('W'), W);
    }
}
export default BorderStyle;
//# sourceMappingURL=BorderStyle.js.map